var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"upload-sheet",attrs:{"color":"white","elevation":"1","height":"100","rounded":"","font-size:":"","small":"","width":"100"}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-check-circle ")]),_c('div',{staticClass:"upload-card-title"},[_c('p',[_vm._v(_vm._s(_vm.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }